export default __webpack_public_path__ + "static/media/Advanced Potion Making - BasedOn-04_00.a4dd4652.jpg";